export const PositionTopStartSubTitle = [{ text: "Print the Position Top Start message. " }];

export const PositionTopEndSubTitle = [{ text: "Print the Position Top End message. " }];

export const PositionBottomStartSubTitle = [{ text: "Print the Position Bottom Start message. " }];

export const PositionBottomEndSubTitle = [{ text: "Print the Position Bottom End message. " }];

export const BasicAlertSubTitle = [{ text: "Print the basic message." }];

export const TitleWithTextSubTitle = [{ text: "Print the title with text message." }];

export const DismissAlertSubTitle = [{ text: "Print the dismiss alert message."}];

export const RichHtmlAlertSubTitle = [{ text: "Print the Rich Html Alert message."}];

export const ConfirmationAlertSunTitle = [{ text: "Print the Confirmation Alert message."}];

export const AnimatedAlertSunTitle = [{ text: "Print the Animated Alert message."}];

export const ConfirmationWithTriggersSubTitle = [{ text: "Print the Confirmation With Triggers message."}];

export const ImageRichMessageSubTitle = [{ text: "Print the Image-Rich MessageT message."}];

export const AutoCloseTimerSubTitle = [{ text: "Print the Auto Close Timer message."}];

export const AJAXRequestAlertSubTitle = [{ text: "Print the AJAX Request Alert message."}];

export const ConfirmationWithApprovalsSubTitle = [{ text: "Print the Confirmation with Approvals message."}];

export const ComprehensiveRTLSupportSubTitle = [{ text: "Print the Comprehensive RTL Support message."}];

export const PasswordGeneratorAlertSubTitle = [{ text: "Print the Password Generator Alert message."}];

export const DateAlertSubTitle = [{ text: "Print the Date Alert message."}];

export const CustomPositionedDialogSubTitle = [{ text: "Print the Custom Positioned Dialog message."}];

export const RegistrationFormSubTitle = [{ text: "Print the Registration Form message."}];
